export default __webpack_public_path__ + "static/media/social-1.35dc13d1.png";